import {
  Avatar,
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  makeStyles,
  Modal,
  Paper,
  Typography,
} from "@material-ui/core";
import { red } from "@material-ui/core/colors";
import { Warning } from "@material-ui/icons";

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import * as ROUTES from "../../constants/routes";
import { withFirebase } from "../Firebase";
import { LoadingPage } from "../LoadingPage";

const EvaluationCard = (props) => {
  /**
   *
   *
   */
  const { data, lang, firebase } = props;

  const uid = firebase.currentUser().uid;
  const { t } = useTranslation();

  const history = useHistory();
  const classes = useStyles();

  const [evalApproved, setevalApproved] = useState(false);
  const [attempState, setattempState] = useState(false); // contiene el estado de si aun puede realizarse mas pruebas
  const [studedState, setstudedState] = useState(false);
  const [isOnProgress, setisOnProgress] = useState(false); // variable para controlar si se esta haciendo o no finished or started
  const [attempNumber, setattempNumber] = useState(-1);
  const [openModal, setopenModal] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [openNewEvalConfirm, setOpenNewEvalConfirm] = useState(false);

  useEffect(() => {
    let metadataRef = firebase.evaluationMetadata(uid, data.id);

    metadataRef.once("value").then((snap) => {
      //console.log("metadata", snap.val().evalApproved);
      if (!!!snap.val()) {
        metadataRef.update({
          nAttemps: -1,
          studed: false,
          evalApproved: false,
          isOnProgress: false,
        });
        setattempState(true);
      } else {
        let attems = !!!snap.val().nAttemps ? 0 : snap.val().nAttemps;
        setattempNumber(attems);
        setattempState(true);
        setstudedState(snap.val().studed);
        setisOnProgress(snap.val().isOnProgress);
        setevalApproved(snap.val().evalApproved);
      }
      setIsLoaded(true);
    });
  }, []);

  const checkAction = () => {
    if (!evalApproved) {
      studedState ? history.push(`/evaluation/${data.id}`) : setopenModal(true);
    } else {
      setOpenNewEvalConfirm(true);
      //history.push(`/evaluation/result/${attempNumber}/${data.id}/${uid}`);
    }
  };
  if (!isLoaded) return <LoadingPage />;

  return (
    <>
      <Card style={{ borderRadius: 16 }}>
        <CardActionArea onClick={checkAction}>
          <CardHeader
            avatar={
              <Avatar
                aria-label="recipe"
                style={{
                  backgroundColor: evalApproved ? "green" : isOnProgress ? "orange" : "red",
                }}
              >
                {!studedState && !evalApproved ? <Warning /> : ""}
              </Avatar>
            }
            title={t(data.title)}
            subheader={evalApproved ? t("evaluationCompleted") : isOnProgress ? t("evaluationOnProgress") : studedState ? t("canStartEvaluation") : t("cantStartEvaluation")}
          />
          <CardMedia component="img" image={t(data.image)} style={{ maxHeight: 250 }} />
        </CardActionArea>
        <CardContent>
          <Typography variant="body1" color="textPrimary">
            {t("attemptNumber", { attempt: attempNumber + 1 })}
          </Typography>
        </CardContent>

        <CardActions>
          <Button
            size="small"
            color="secondary"
            disabled={(attempNumber < 1 && isOnProgress) || attempNumber < 0}
            onClick={() =>
              isOnProgress ? history.push(`/evaluation/result/${attempNumber - 1}/${data.id}/${uid}`) : history.push(`/evaluation/result/${attempNumber}/${data.id}/${uid}`)
            }
          >
            {t("viewLastAttempt")}
          </Button>
          <Button size="small" color="primary" onClick={checkAction}>
            {isOnProgress ? t("continue") : t("start")}
          </Button>
        </CardActions>
      </Card>

      <Modal open={openModal} onClose={() => setopenModal(false)} className={classes.modal}>
        <div className={classes.paper}>
          <Typography variant="h5">{t("firstCompleteFormation")}</Typography>
          <Grid container direction="row" style={{ marginTop: 32 }}>
            <Grid item xs={6} container alignItems="center" justify="flex-start">
              <Button
                style={{ color: "red" }}
                onClick={() => {
                  setopenModal(false);
                }}
              >
                {t("close")}
              </Button>
            </Grid>
            <Grid item xs={6} container alignItems="center" justify="flex-end">
              <Button
                color="primary"
                variant="outlined"
                onClick={() => {
                  setopenModal(false);
                  history.push(`/course/${data.course}`);
                }}
              >
                {t("goToFormation")}
              </Button>
            </Grid>
          </Grid>
        </div>
      </Modal>

      <Dialog open={openNewEvalConfirm} onClose={() => setOpenNewEvalConfirm(false)}>
        <DialogTitle id="alert-dialog-title">{t("newEvaluationConfirmTitle")}</DialogTitle>
        <DialogContent>
          <DialogContentText>{t("newEvaluationConfirmText")}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenNewEvalConfirm(false)} style={{ color: red[600] }}>
            {t("declineNewEvaluation")}
          </Button>
          <Button
            onClick={() => {
              setOpenNewEvalConfirm(false);
              history.push(`/evaluation/${data.id}`);
              //firebase.userReport(uid).child();
              /*history.push(
                `/evaluation/result/${attempNumber}/${data.id}/${uid}`
              );*/
            }}
            color="primary"
            variant="contained"
            autoFocus
          >
            {t("startNewEvaluation")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default withFirebase(EvaluationCard);

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    position: "absolute",

    backgroundColor: theme.palette.background.paper,
    borderRadius: 12,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));
